<template>
  <div class="pool-calibration">

    <div class="cal-switch clickable" @click="clickSwitch">
      <div>{{calibrationSwitch.name}}</div>
      <img class="icon" :src="calibrationSwitch.icon"/>
      <div>{{switchValue?"已打开":"已关闭"}}</div>
    </div>

    <div class="item" v-for="item in calibrationArray">
      <div class="name">{{ item.name }}传感器校正</div>

      <div class="data-item" v-for="(dataItem,index) in valueNameArray" v-bind:class="{clickable:index>1}" @click="clickItem(item,index)">
        <div class="value">{{item.valueArray[index]}}</div>
        <div class="title">{{dataItem}}</div>
      </div>

<!--      <div class="recover clickable" v-bind:style="{background:item.color}" @click="clickReset(item)">恢复出厂<br/>设置状态</div>-->

    </div>

    <InputDialog ref="inputDialog"></InputDialog>
  </div>
</template>

<script>
import InputDialog from "@/components/dialog/InputDialog";
export default {
  components:{InputDialog},
  props: ["valueMap","calibrationArray","calibrationSwitch"],
  computed: {
    valueNameArray() {
      return [
        "当前值",
        "1-3点采样值",
        "采样值-1",
        "标准值-1",
        "采样值-2",
        "标准值-2",
        "采样值-3",
        "标准值-3",
      ]
    },
    switchValue(){
      return this.valueMap[this.calibrationSwitch.dataId] || 0
    }
  },
  methods:{
    clickItem(item,index){
      if(index<=1){
        return
      }
      let that = this
      let dataId = item.dataIdArray[index]
      let value = item.valueArray[index]
      let title = this.valueNameArray[index]
      this.$refs.inputDialog.show({
        title:item.name + "探头三点校准 - " + title,
        value:value,
        onOk(value){
          that.$emit("control",dataId,value)
        }
      })
    },
    clickReset(item){
      let that = this
      this.$confirm({
        title: item.name + "探头三点校准",
        content: '是否恢复出厂设置状态',
        centered: true,
        onOk () {
          that.$emit("control",item.resetDataId,1)
        }
      })
    },
    clickSwitch(){
      let value = this.switchValue==1?0:1
      this.$emit("control",this.calibrationSwitch.dataId,value)
    }
  }
}
</script>

<style lang="less" scoped>
.pool-calibration {
  font-size: 1vw;
  position: relative;

  .cal-switch{
    text-align: center;
    background: rgba(0,0,0,0.2);
    padding: 1vw 2vw;
    border-radius: 10px;
    position: absolute;

    .icon{
      width: 3vw;
      height: 3vw;
      margin: 5px;
    }
  }

  .item{
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .name{
      text-align: right;
      display: flex;
      width: 8vw;
      text-align: center;
      flex-direction: column;
      justify-content: center;
      margin-right: 20px;
      font-size: 0.8vw;
      background: #053062;
      border-radius: 6px;
    }

    .data-item{
      background: #053062;
      margin-right: 5px;
      text-align: center;
      border-radius: 6px;
      overflow: hidden;

      .value{
        font-size: 1.3vw;
      }

      .title{
        background: #05407A;
        width: 5vw;
        color: #FFF;
        font-size: 0.7vw;
        padding: 2px;
      }
    }

    .recover{
      background: #999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 30px;
      color: #FFF;
    }
  }
}
</style>
